/**
 * Central brand configuration — the single source of truth for every
 * brand-facing string and the logo wordmark. Reskinning the app to a different
 * brand is a one-file change: update the values here and (optionally) the color
 * tokens in scss/_theme.scss + the PWA assets (public/manifest.json,
 * public/favicon.svg, public/icons/*). Nothing else hardcodes the brand name.
 *
 * Colors live as CSS variables in _theme.scss (--brand-primary, --brand-info);
 * the logo reads them so a palette change repaints the mark automatically.
 */
export const BRAND = {
  // Full product name — used in titles, footers, hero copy, aria labels.
  name: 'AFC Group Connect',
  // Short name — tight spaces, PWA install prompt, mobile web-app title.
  shortName: 'AFC Connect',
  // Legal entity for the copyright line.
  legalName: 'AFC Group Connect',

  // Logo wordmark. The badge is the square glyph; word1/word2 are the two
  // stacked wordmark lines beside it. Set word2 to '' for a single-line mark.
  logo: {
    badge: 'AFC',
    word1: 'Group',
    word2: 'Connect',
  },

  // Tagline shown on the public/auth hero panel.
  tagline: 'One platform for referrals, commissions, and growth.',
};

export default BRAND;
